import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import styles from "./styles.module.scss";

interface WideHeaderProps {
    title: string;
    children: JSX.Element | JSX.Element[];
}

/* eslint-disable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment */
const WideHeader = ({ title, children }: WideHeaderProps): JSX.Element => {
    return (
        <div className={ styles.header }>
            <Helmet title={ `${ title } - Bloomberg` } />
            <h1 className={ styles.title }>{ title }</h1>
            { children }
        </div>
    );
};

WideHeader.propTypes = {
    title: PropTypes.string
};

export default WideHeader;
